export class ReferralMappingMappedValue {
  sourceValue = '';

  destinationValue = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
